import { createAction } from '@wix/communities-blog-client-common';

export const actionsOpened = createAction('moreButton/ACTIONS_OPENED');
